import React, { useEffect, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import moment from "moment"
import { useNavigate } from 'react-router-dom';

import { Card, Col, Row } from 'react-bootstrap';
import Swal from 'sweetalert2';
import CircleLoader from "react-spinners/CircleLoader";


import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTablePagination from 'components/common/advance-table/AdvanceTablePagination';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';

import { 
	fetchEmetResultFinish,
	fetchEmetResultByCertificationId,
	fetchEmetScoreStatisticsByCertification
 } from 'api/certifications/emet/results';

import { 
	generateEmetResult,
	updateCertFileByCertificationId
} from 'api/certifications/certifications';

import { exportEmetEstadistico, exportEvaluatedEmet, getCertificationType, handleApiError } from 'utils';


import Header from './header/Header';
import CertificateColumns from './columns/EMETColumns';
import { fetchEmetQuestionsReportHeaders } from 'api/certifications/emet/questions';



const override = {
    display: "block",
    margin: "0 auto",
    borderColor: "red"
};

const EmetCertificationFinish = () => {
    const token = useSelector(state => state.authentication.user?.token);
	const navigate = useNavigate();
    
    const [certifications, setCertifications] = useState([]); 
	const [rows, setRows] = useState([]); 

	const [action, setAction] = useState("");
    const [questionId, setQuestionId] = useState(0);

	const [selectedRows, setSelectedRows] = useState({});

	const [loading, setLoading] = useState(false);

    useEffect(() => {
		if(token !== null && token !== undefined)
            loadEmetResultFinish();
		// eslint-disable-next-line
    }, [token]);

    useEffect(() => {
		if (certifications.length > 0) {
            const formattedCertifications = certifications.map((certification, index) => {
			
                return {
                    index: index++,
					certification_id: certification.certification_id,
					name: certification.name,
					email: certification.email,
					college: certification.college,
					assigned_date: moment(certification.assigned_date).format("DD/MM/YYYY"),
					completed_date: moment(certification.completed_date).format("DD/MM/YYYY HH:mm:ss"),
					certification_type: getCertificationType(certification.certification_type),
					total_score: certification.total_score,
					total_percentage: `${certification.total_percentage}%`,
					level: certification.level,
					section_1: certification.total_section_1,
					percentage_section_1: `${certification.percentage_section_1}%`,
					section_2: certification.total_section_2,
					percentage_section_2: `${certification.percentage_section_2}%`,
					section_3: certification.total_section_3,
					percentage_section_3: `${certification.percentage_section_3}%`,
					section_4: certification.total_section_4,
					percentage_section_4: `${certification.percentage_section_4}%`

                };
            });
			setRows(formattedCertifications);
		}
		// eslint-disable-next-line
	}, [certifications]);

    const loadEmetResultFinish = async () => {
        try {
			setLoading(true);
            const response = await fetchEmetResultFinish(token);
			setCertifications(response.data.message);
        } catch (error) {
			handleApiError(error);
			setLoading(false);
		} finally {
			setLoading(false);
		}
    };

	const handleEmetResultByCertificationId = async (certification_id, name, email, total_score, level, completed_date) => {
		try {
			const response = await fetchEmetResultByCertificationId(certification_id, token);
			const certificationFile = response?.data?.message?.certification_file;
	
			if (!certificationFile) {
				Swal.fire({
					title: "Archivo de certificación no encontrado",
					text: "El archivo de certificación aún no ha sido generado. ¿Deseas generarlo ahora?",
					icon: "warning",
					confirmButtonText: "Generar archivo",
					cancelButtonText: "Cancelar",
					showCancelButton: true,
					showCloseButton: true,
					allowOutsideClick: false,
					allowEscapeKey: false,
					allowEnterKey: false,
					reverseButtons: true
				}).then((result) => {
					if (result.isConfirmed) {
						moment.locale("en");
						const formattedDate = moment(completed_date, "DD/MM/YYYY HH:mm:ss").format("dddd, DD MMMM YYYY");
						const data = {
							name: name,
							date: formattedDate,
							score: total_score,
							title: level,
							email: email
						}
						handleGenerateEmetResult(certification_id, data, name);
					}
				});
			} else {
				const encodedFilename = encodeURIComponent(certificationFile);
				window.open(`${process.env.REACT_APP_CERTIFICATIONS_API}/files/download/1/${encodedFilename}`, "_blank", "noopener,noreferrer");
			}
		} catch (error) {
			handleApiError(error);
		}
	};

	const handleGenerateEmetResult = async (certification_id, data, name) => {
		try {
			const response = await generateEmetResult(data, token);
			if(response.data.status === 200) {
				const data = {
					certification_file: response.data.output_file
				}
				handleUpdateCertFileByCertificationId(certification_id, data, name);
			}
		} catch (error) {
			handleApiError(error);
		}
	};

	const handleUpdateCertFileByCertificationId = async (certification_id, data, name) => {
		try {
			const response = await updateCertFileByCertificationId(certification_id, data, token);
			if(response.data.status === 200) {
				Swal.fire({
					title: "¡Certificado generado y enviado!",
					text: `El certificado ha sido generado correctamente y enviado al candidato ${name}.`,
					icon: "success",
					confirmButtonText: "Aceptar",
					showCloseButton: true,
					allowOutsideClick: false,
					allowEscapeKey: false,
					allowEnterKey: false
				});
			}
		} catch (error) {
			handleApiError(error);
		}
	};

	const handleDeleteCertification = async (certification_id) => {
		
	};

	const handleExport = () => {
		Swal.fire({
			title: '¿Deseas descargar el reporte de certificaciones?',
			text: 'Se generará un archivo con la información detallada de las certificaciones evaluadas.',
			icon: "question",
			confirmButtonText: 'Continuar',
			cancelButtonText: 'Cancelar',
			showCancelButton: true,
			showCloseButton: true,
			allowOutsideClick: false,
			allowEscapeKey: false,
			allowEnterKey: false,
			reverseButtons : true
		}).then((result) => {
			if (result.isConfirmed) 
				exportEvaluatedEmet(certifications);
		}).catch(() => {
			return false;
		})
	}

	const handleOpenCertification = (certification_id,name, email, total_score, level, completed_date, college, certification_type) => {
		let certification = {
			id: certification_id, 
			name: name,
			email: email, 
			college_name: college, 
			certification_type: certification_type, 
			completed_date: completed_date, 
			total_score: total_score,
			level: level
		}

		navigate('/examiner/view/emet', {
			state: { certification }
		});
	};
	
	const handleShowFile = (certification_id, name, email, total_score, level, completed_date) => {
		handleEmetResultByCertificationId(certification_id, name, email, total_score, level, completed_date);
		
	};

	const handleDelete = (certification_id, name) => {
		Swal.fire({
			title: `¿Deseas eliminar la certificación de ${name}?`,
			text: "Una vez eliminado ya no estara disponible.",
			icon: "question",
			confirmButtonText: 'Continuar',
			cancelButtonText: 'Cancelar',
			showCancelButton: true,
			showCloseButton: true,
			allowOutsideClick: false,
			allowEscapeKey: false,
			allowEnterKey: false,
			reverseButtons : true
		}).then((result) => {
			if (result.isConfirmed) 
				confirmDeleteCertification(certification_id);
		}).catch(() => {
			return false;
		})
	};

	const confirmDeleteCertification = (certification_id) => {
		Swal.fire({
			title: "¿Estas seguro?",
			text: "Esta operacion no se puede deshacer.",
			icon: "warning",
			confirmButtonText: 'Eliminar',
			cancelButtonText: 'Cancelar',
			showCancelButton: true,
			showCloseButton: true,
			allowOutsideClick: false,
			allowEscapeKey: false,
			allowEnterKey: false,
			reverseButtons : true
		}).then((result) => {
			if (result.isConfirmed) {	
				handleDeleteCertification(certification_id);
			}
		}).catch(() => {
			return false;
		})
	}

	const handleDownloadReports = async (rows) => {
		try {
			setLoading(true);

			const data_export = [];

			const { data } = await fetchEmetQuestionsReportHeaders(token);
			
			for (const r of rows) {
				const response = await fetchEmetScoreStatisticsByCertification(r.certification_id, token);
				const rowData = [r.email, r.name, ...response.data];

				data_export.push(rowData);
			}	
			
			// Exportar ambos si tienen datos
			exportEmetEstadistico(data, data_export);
		} catch (error) {
			handleApiError(error);
			setLoading(false);
		} finally {
			setLoading(false);
		}
	}

	const handleDownloadReport = async (certification_id, email, nombre) => {
		try {
			let arrays_data = []
			setLoading(true);
			const { data } = await fetchEmetQuestionsReportHeaders(token);
			if(data) {
				const response = await fetchEmetScoreStatisticsByCertification(certification_id, token);

				// Construir una fila con email, nombre y respuestas
				const row = [email, nombre, ...response.data];
				arrays_data.push(row);

				// Exportar todo el dataset
				exportEmetEstadistico(data, arrays_data);
			}
		} catch (error) {
			handleApiError(error);
			setLoading(false);
		} finally {
			setLoading(false);
		}
		
	};
	

	/**
	 * @function handleBulkAction
	 * @description
	 * Ejecuta acciones en lote según la selección (exportar, eliminar, etc).
	 *
	 * @param {string} action - Tipo de acción ('export', 'delete', etc.)
	 */
	const handleBulkAction = (action) => {
		if (action === 'export') {
			handleDownloadReports(selectedRows);
		} else if (action === 'delete') {
			//handleBulkDelete();
		}
	};

	/**
	 * @function handleSelectedChange
	 * @description
	 * Maneja el cambio de selección en la tabla. Extrae los `index` seleccionados desde `selectedData`
	 * y filtra las filas (`rows`) que coincidan con esos índices. Actualiza el estado `selectedRows` con las filas seleccionadas.
	 *
	 * Esta función está memorizada con `useCallback` para evitar recrearse innecesariamente,
	 * y depende del estado actual de `rows`.
	 *
	 * @param {Object} selectedData - Objeto con las claves de las filas seleccionadas, por ejemplo: { '0': true, '2': true }.
	 * Las claves representan los índices (`index`) de las filas seleccionadas.
	 *
	 * @returns {void}
	 */
	const handleSelectedChange = useCallback((selectedData) => {
		const selectedIds = Object.keys(selectedData).map(id => parseInt(id, 10));
		setSelectedRows(rows.filter(row => selectedIds.includes(row.index)));
	}, [rows]);

    return (
		<Row className="gx-3">
			{loading ? (
				<div className="sweet-loading" style={{
					position: 'fixed',
					top: 0,
					left: 0,
					width: '100vw',
					height: '100vh',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					backgroundColor: 'rgba(255, 255, 255, 0.8)', // Puedes agregar un fondo semitransparente si lo deseas
					zIndex: 9999}} >
					<CircleLoader
						color={"#0a83e6"}
						loading={loading}
						cssOverride={override}
						size={150}
						aria-label="Loading..."
						data-testid="loader"
					/>
				</div>
			) : (
				<>
					<Col xxl={12} xl={12}>
						<AdvanceTableWrapper
							columns={CertificateColumns(handleOpenCertification, handleDownloadReport, handleShowFile, handleDelete)}
							data={rows}
							selection
							selectionColumnWidth={52}
							sortable
							pagination
							perPage={10}
							rowCount={rows.length}
						>
							<Card>
								<Card.Header className="px-0">
									<Header table handleSelectedChange={handleSelectedChange} handleExport={handleExport} onBulkAction={handleBulkAction} />
								</Card.Header>
								<Card.Body className="p-0">
									<AdvanceTable
										table
										headerClassName="bg-light text-800 align-middle"
										rowClassName="btn-reveal-trigger align-middle"
										tableProps={{
											size: 'sm',
											className: 'fs--1 mb-0 overflow-hidden'
										}}
									/>
								</Card.Body>
								<Card.Footer>
									<AdvanceTablePagination table />
								</Card.Footer>
							</Card>
						</AdvanceTableWrapper>
					</Col>
					
					
				</>
			)}
		</Row>
	);
};

export default EmetCertificationFinish;

/*
<Col xxl={2} xl={3}>
						{breakpoints.down('xl') ? (
						<Offcanvas
							show={show}
							onHide={handleClose}
							placement="end"
							className="dark__bg-card-dark"
						>
							<Offcanvas.Header closeButton className="bg-light">
							<h6 className="fs-0 mb-0 fw-semi-bold">Filter</h6>
							</Offcanvas.Header>
							<ContactsFilteringForm />
						</Offcanvas>
						) : (
						<ContactsFilteringForm />
						)}
					</Col>
*/